import { Component, JSX, Prop, h } from '@stencil/core'

@Component({
  tag: 'air-list-item',
  styleUrl: 'air-list-item.scss',
  shadow: true,
})
export class AirListItem {
  /** Defines the item text */
  @Prop() text!: string

  /** Defines the item numerics */
  @Prop() order: number | undefined

  /** Defines the item as checked */
  @Prop() checked = false

  /** Defines checkmark icon name */
  @Prop() checkmark = 'check'

  private renderItemPrefix(): HTMLSpanElement {
    const { order } = this
    return order !== undefined ? (
      <span class="list-item-order">{order}</span>
    ) : (
      <span class="list-item-bullet"></span>
    )
  }

  render(): JSX.Element {
    return (
      <div class="list-item">
        {this.renderItemPrefix()}
        <span class="list-item-text">{this.text}</span>
        {this.checked && <air-icon class="list-item-checkmark" name={this.checkmark}></air-icon>}
      </div>
    )
  }
}
